// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"loading_spinnerWrapper__ymcjU","overContent":"loading_overContent__60mrq","spinnerWrapperLocal":"loading_spinnerWrapperLocal__-x9Jw"};